import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CategoryModel } from '../models/category.model';
import { ShopService } from '../services/shop.service';

export const CategoryResolver: ResolveFn<Observable<CategoryModel[]>> = () => {
  const shopService: ShopService = inject(ShopService);

  return <Observable<CategoryModel[]>>shopService.getCategories().pipe(
    catchError(() => {
      return of({});
    })
  );
};
